import { jsonb, pgEnum, pgTable, text, unique, uuid } from "drizzle-orm/pg-core";
import { relations } from "drizzle-orm";
import { allOrNone, id, temporalDate, timestamps } from "../../utils/sql";
import { user } from "../../auth/core/user.sql";
import { bodyMetric } from "../body-metric/body-metric.sql";
import type { BodyMetricGroupType } from "../body-metric/constants";
import { unit } from "../../common/unit/unit.sql";
import type { NumericTarget } from "@corpuscomplete/core/common/numeric-target";
import type { Unit } from "@corpuscomplete/core/common/unit";

export const goalEndReason = pgEnum("goal_end_reason", [
  "achieved",
  "missed",
  "canceled",
  "replaced",
]);

export const bodyMetricGoal = pgTable(
  "body_metric_goal",
  {
    ...id,
    ...timestamps,
    userId: uuid("user_id")
      .references(() => user.id)
      .notNull(),
    type: text("type").$type<BodyMetricGroupType>().notNull(),
    dateStart: temporalDate("date_start").notNull(),
    dateTarget: temporalDate("date_target"),
    dateEnd: temporalDate("date_end"),
    endReason: goalEndReason("end_reason"),
  },
  (t) => [allOrNone("body_metric_goal_end_consistency", [t.dateEnd, t.endReason])],
);

export const bodyMetricGoalRelations = relations(bodyMetricGoal, ({ many }) => ({
  targets: many(bodyMetricTarget),
}));

export const bodyMetricTarget = pgTable(
  "body_metric_target",
  {
    ...id,
    ...timestamps,
    goalId: uuid("goal_id")
      .references(() => bodyMetricGoal.id)
      .notNull(),
    metricId: uuid("metric_id")
      .references(() => bodyMetric.id)
      .notNull(),
    target: jsonb("target").$type<NumericTarget.Info>().notNull(),
    unitKey: text("unit_key")
      .references(() => unit.key)
      .$type<Unit.Key>()
      .notNull(),
  },
  (t) => [unique("body_metric_target_unique").on(t.goalId, t.metricId)],
);

export const bodyMetricTargetRelations = relations(bodyMetricTarget, ({ one }) => ({
  goal: one(bodyMetricGoal, {
    fields: [bodyMetricTarget.goalId],
    references: [bodyMetricGoal.id],
  }),
  metric: one(bodyMetric, {
    fields: [bodyMetricTarget.metricId],
    references: [bodyMetric.id],
  }),
  unit: one(unit, {
    fields: [bodyMetricTarget.unitKey],
    references: [unit.key],
  }),
}));
